const Hashes = require('jshashes');
const getHmacDigestValue = (finalString, publicKey) => new Hashes.SHA512().b64_hmac(publicKey, finalString);
module.exports = {
  getHmacDigestValue,
};
